import { OBJECTIVES_2_0_0 } from "./objectives-2.0.0.js";
import { ALL_TASKS } from "./task-defs.js";
/**
 * Content bundle 2.0.0 — the teacher's curriculum.
 *
 * **Bundle 1.0.0 was deleted rather than kept, and that is worth defending.** ADR-002 makes a
 * bundle the pinning unit precisely so that a released one is never edited, so the instinct is
 * to leave it alone and add beside it. That instinct is right when the old bundle still
 * describes something: a child with a recorded trajectory measured against it.
 *
 * Nobody had one. 1.0.0 was `frozen: false`, no live profile was ever pinned to it, and the
 * pivot changed what a task IS — errors no longer end a task, the difficulty ladders were
 * re-cut into objective windows, and there are numerals on the screen. Keeping it would have
 * meant maintaining fifteen task definitions nobody can be assigned to, through every future
 * schema change, in order to honour a rule protecting data that does not exist.
 *
 * What survives is the rule itself. This bundle carries the tasks AND the objectives, so a
 * student's "mastered adding to ten" is only ever read against the level windows it was
 * recorded under — and the moment a real class is pinned here, `frozen` flips and the same
 * argument stops being available.
 */
export const BUNDLE_2_0_0 = {
    bundleVersion: "2.0.0",
    // Flip to true the moment any live class is pinned to it. After that, edits are forbidden —
    // a new bundle plus recorded re-equating is the only legal path (ADR-002).
    frozen: false,
    tasks: [...ALL_TASKS],
    objectives: [...OBJECTIVES_2_0_0],
};
//# sourceMappingURL=bundle-2.0.0.js.map